module.exports = __webpack_public_path__ + "img/bonus_symbol_1.43d71202.png";